import { useState } from "react";
import { IChart } from "../../../../../@types/chart.type";
import iconDelete from "./../../../../../assets/_TrashIcon_gray.svg";
import { GridBaseWidget } from "../../GridBaseWidget";
import { ColDef, IGetRowsParams } from "ag-grid-community";
import { getResourcesCostOfIdleness } from "../../../../../services/api/widgets/widgetsService";
import { IApiResponse } from "../../../../../@types/api-response.type";
import { storageUserGet } from "../../../../../storage/storageUser";
import { ResourcesCostOfIdlenessDto } from "../../../../../@types/widgets.type";
import { IconCostIdleness } from "../../../../../icons/IconCostIdleness";
import styles from "./styles.module.scss";
import { CustomCellRendererProps } from "ag-grid-react";
import { formatCurrency } from "../../../../../utils/formatCurrency";

interface CostPerMonthIdlenessProps {
  chart: IChart;
  ismodeEdit: boolean;
  deleteChart: (id: string | undefined, widgetId: string) => void;
  rowHeightGrid: number;
}

const columns: ColDef[] = [
  {
    field: "id",
    headerName: "ID",
    hide: true,
  },
  {
    field: "resourceName",
    headerName: "Nome",
    flex: 1,
  },
  {
    field: "managerName",
    headerName: "Gestor",
    flex: 1,
  },
  {
    field: "idleHours",
    headerName: "Horas não alocadas",
    cellRenderer: (params: CustomCellRendererProps) => {
      return `${params.value}h`;
    },
    flex: 1,
  },
  {
    field: "cost",
    headerName: "Custo",
    cellRenderer: (params: CustomCellRendererProps) => {
      return formatCurrency(params.value);
    },
    flex: 1,
  },
];

export function CostPerMonthIdleness({
  chart,
  deleteChart,
  ismodeEdit,
}: CostPerMonthIdlenessProps) {
  const [loading, setLoading] = useState<boolean>(false);

  const user = storageUserGet();

  async function fetchResourcesCostOfIdleness(params: IGetRowsParams) {
    const paramsBody = {
      managerId: user.resourceId as string,
      skip: params.startRow, // Linha inicial para paginação
      take: params.endRow - params.startRow, // Quantidade de linhas
    };

    try {
      setLoading(true);
      const response = (await getResourcesCostOfIdleness(
        paramsBody
      )) as IApiResponse<ResourcesCostOfIdlenessDto>;

      if (response.statusCode === 200) {
        params.successCallback(
          response.result.items,
          response.result.totalRows
        );
      }
    } catch (error) {
      console.log(error);
      params.failCallback();
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={styles.widget}>
      <div className={styles.header}>
        <h3>
          <IconCostIdleness size={26} />
          Custo de Ociosidade da Minha Equipe
        </h3>
      </div>
      <div style={{ width: "100%", height: "100%" }}>
        <GridBaseWidget
          columns={columns}
          fetchData={fetchResourcesCostOfIdleness}
          loading={loading}
        />
      </div>
      {ismodeEdit && (
        <button onClick={() => deleteChart(chart.id, chart.widgetId)}>
          <img src={iconDelete} alt="" />
        </button>
      )}
    </div>
  );
}
